<div class="col element-zoom m-0" [ngStyle]="contentStyle">
  <div class="widget-wrapper address open position-relative" [ngStyle]="borderStyle" style="min-height: 100%">
    <form [formGroup]="addressForm">
      <div class="form-wrapper">
        <ng-container *ngIf="searchAddressFieldAttribute as field">
          <label
            *ngIf="field.label && labelType !== labelTypeOptions.PLACEHOLDER"
            [class.labelActive]="isSearchAddressInputOnFocus"
            [class.floatingLabelWithValue]="
              searchAddressFieldValue !== '' && labelType === labelTypeOptions.FLOATING
            "
            [class.floatingLabel]="labelType === labelTypeOptions.FLOATING"
            class="labelText labelIdle labelConfig"
            [for]="fieldId(field.name)"
            >{{ field.label }}</label
          >
          <finxone-autocomplete-input
            inputIcon=""
            toggleIcon=""
            [id]="fieldId(field.name)"
            [filteredOptions]="filteredAddress"
            [loading]="isSearchingAddress"
            [optionLabelKey]="'address'"
            [optionValueKey]="'id'"
            [customOptionTemplate]="addressOptionTemplate"
            [label]="labelType === labelTypeOptions.PLACEHOLDER ? field.label : ''"
            [class]="'w-100'"
            (searchChanged)="onSearchAddressChange($event)"
            (valueChanged)="onAddressOptionSelected($event)"
            (focusEvent)="isSearchAddressInputOnFocus = true"
            (blurEvent)="isSearchAddressInputOnFocus = false"
          ></finxone-autocomplete-input>
          <ng-template #addressOptionTemplate let-option>{{ option?.address }}</ng-template>
          <div class="labelText labelIdle labelConfig separator" [ngStyle]="colorTextAlignStyle">Or</div>
          <div class="d-flex">
            <span class="labelText labelIdle labelConfig" [ngStyle]="colorTextAlignStyle">
              @if (attri?.['sub_heading']) {
                {{ attri?.['sub_heading'] }}
              }
            </span>
          </div>
        </ng-container>

        <div class="finxForm" [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}">
          <div class="w-100" *ngFor="let field of widgetConfig.attributes['field_attributes']">
            <ng-container>
              <ng-container
                *ngIf="
                  field.type !== 'country' &&
                  field.type !== 'search_address' &&
                  field.type !== 'city_postal_code' &&
                  field.type !== 'dropdown'
                "
              >
                <ng-container
                  *ngTemplateOutlet="addressInput; context: { field: field, formGroup: addressForm }"
                ></ng-container>
              </ng-container>

              <ng-container *ngIf="field.type === 'country'">
                <ng-container
                  *ngTemplateOutlet="countryInput; context: { field: field, formGroup: addressForm }"
                ></ng-container>
                <div
                  class="text-error"
                  *ngIf="addressForm?.get(field.name)?.invalid && addressForm?.get(field.name)?.touched"
                >
                  <p>{{ field.label }} is a required field</p>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <ng-container *ngIf="addressHistoryExtraTemplate">
            <ng-container
              *ngTemplateOutlet="addressHistoryExtraTemplate; context: addressHistoryExtraContext"
            ></ng-container>
          </ng-container>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-template #addressInput let-field="field" let-formGroup="formGroup">
  <div [formGroup]="formGroup" class="mb-2">
    <finxone-input
      [disableAutocomplete]="disableAutocomplete"
      [type]="field.type"
      [label]="field.label"
      [formControlName]="field?.name"
      [formControlInvalid]="
        !!(addressForm?.controls?.[field?.name]?.touched && addressForm?.controls?.[field?.name]?.invalid)
      "
      [validationConfig]="[
        {
          type: field?.decision_config?.required ? 'required' : '',
          message: stripAsterisks(field?.requiredMessage || field?.label) + ' is a required field',
        },
      ]"
      [value]="addressForm?.get(field.name)?.value ?? ''"
      [readOnly]="!isAllowedManualEdit"
    >
    </finxone-input>
  </div>
</ng-template>

<ng-template #countryInput let-field="field" let-formGroup="formGroup">
  <div [formGroup]="formGroup">
    <label
      *ngIf="field.label && labelType !== labelTypeOptions.PLACEHOLDER"
      [class.labelActive]="isInputOnFocus"
      [class.floatingLabelWithValue]="selectedCountry.code !== '' && labelType === labelTypeOptions.FLOATING"
      [class.floatingLabel]="labelType === labelTypeOptions.FLOATING"
      class="labelText labelIdle labelConfig"
      [for]="fieldId(field.name)"
      (click)="handleLabelClick()"
      >{{ field.label }}</label
    >
    <finxone-autocomplete-input
      inputIcon=""
      toggleIcon=""
      [id]="fieldId(field.name)"
      [filteredOptions]="filteredCountries"
      [selectedOption]="selectedCountry"
      [optionLabelKey]="'name'"
      [optionValueKey]="'code'"
      [customOptionTemplate]="countryOptionTemplate"
      [label]="labelType === labelTypeOptions.PLACEHOLDER ? field.label : ''"
      [class]="'autocomplete w-100'"
      [isDisabled]="!isAllowedManualEdit"
      (searchChanged)="filterCountries($event)"
      (valueChanged)="onCountryInputChange($event)"
      (focusEvent)="isInputOnFocus = true"
      (blurEvent)="isInputOnFocus = false; onTouched()"
    ></finxone-autocomplete-input>
    <ng-template #countryOptionTemplate let-option>{{ option?.name }}</ng-template>
  </div>
</ng-template>
